import React, { useEffect, useState } from "react";
import axios from "axios";
// import Header from "../../../cmponents/Header/Header";
import UniversitiesTable from "./DistrictTable";
// import Image from "next/image";

function Main(props) {
  const [formDataLength, setFormDataLength] = useState(0);

  useEffect(() => {
    axios
      .get("https://backend.form-seef.com/api/domiciles")
      .then((res) => {
        if (res) {
          setFormDataLength(res.data.data.length);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      
      
        <div className="flex flex-col items-center justify-center mt-2">
          <div className="bg-white rounded-lg shadow-md p-4 hover:transform hover:-translate-y-2 hover:bg-slate-300 hover:transition hover:duration-300 hover:ease-in-out flex flex-col items-center">
            {formDataLength ? (
              <div
                style={{
                  width: 60,
                  height: 20,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: 30,
                  fontWeight: "bold",
                }}
              >
                {formDataLength}
              </div>
            ) : (
              <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
            Loading...
          </div>
            )}

            <div className="p-2 text-center">
              <h2 className="font-bold text-lg mb-2">Total Districts</h2>
              <p className="text-gray-700 text-base">Total Districts under Province Sindh</p>
            </div>
          </div>
        </div>

        <div className="w-full">
          <UniversitiesTable open={props.open} setOpen={props.setOpen} setFormDataLength={setFormDataLength} />
        </div>

    </>
  );
}

export default Main;
